import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { AppConfigService } from './shared/services/app-config.service';
import { AuthenticationService } from './shared/services/authentication.service';
import { PathsToExcludeConstant } from './shared/global/pathsToExclude.contants';
import { UserService } from './shared/services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ben-root',
  templateUrl: './app.component.html'
})

export class AppComponent {
  title = 'Benenden Community';
  loading: boolean = true;
  isAuthenticated: boolean = false;
  pageUrl: string;
  
  constructor(private location: Location,
    private appConfgiService: AppConfigService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router) {
      this.pageUrl = this.location.path();

    if (!this.appConfgiService.configLoaded) {
      this.appConfgiService.getAppConfig().subscribe(_ => {})
    }
    this.authenticationService.isUserLoggedIn().subscribe(data => {
      this.isAuthenticated = data;
      if(data){
        this.userService.GetSpectrumID().subscribe(_ => { })
      }
      this.loading = false;
    })


    this.authenticationService.checkAuthState();
  }

  showElementBasedOnPath() {
    let pageUrl = this.location.path();
    return PathsToExcludeConstant.indexOf(pageUrl) === -1;
  }
}

